<template>
  <div class="max-w-screen-xl m-auto px-4 py-10">
    <Heading
      h-class="text-h3"
      :level="2"
      :title="content.title"
      :use-h-tag="false"
      class="mb-4 kft-product-showcase__heading kft-heading--left"
    />
    <span v-if="content?.subtitle" class="mb-8 block">
      {{ content?.subtitle }}
    </span>
    <div class="border border-stone-200 rounded-md mt-10">
      <div
        v-for="item in content?.questions"
        :key="item?.id"
        class="border-b last:border-none"
      >
        <Disclosure v-slot="{ open }" as="div" :default-open="true">
          <DisclosureButton
            as="div"
            class="flex w-full justify-between items-center px-4 py-4 text-left text-lg font-medium cursor-pointer bg-stone-50"
          >
              <span>{{ item?.question }}</span>
            <IconChevronDown
              :class="open ? 'rotate-180 transform' : ''"
              class="h-3 w-3 ease duration-300"
            />
          </DisclosureButton>
          <DisclosurePanel as="div" class="p-4 text-normal text-black">
            {{ item?.answer }}
          </DisclosurePanel>
        </Disclosure>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import IconChevronDown from '~/components/icons/IconChevronDown'
import IconQuestion from '~/components/icons/IconQuestion'

const { content = {} } = defineProps<{ content: any }>()
</script>
